export default "__VITE_ASSET__DJk0NZe4__"